import React from 'react';
import { AlertTriangle } from 'lucide-react';

export const StageJurisdiction = function({ planData, updateData }) {

  return (

          <div className="space-y-6">
            <div className="bg-[#2D2560]/10 border border-[#2D2560]/30 rounded-lg p-4">
              <div className="flex items-start gap-3">
                <AlertTriangle className="w-5 h-5 text-[#2D2560] flex-shrink-0 mt-0.5" />
                <div className="text-sm">
                  <p className="font-semibold text-[#2D2560] mb-1">Educational Tool - Not Legal Advice</p>
                  <p className="text-white/80">
                    This tool helps you organize your thoughts. It does not create an attorney-client relationship.
                    Consult with a lawyer about your specific situation.
                  </p>
                </div>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">State</label>
              <select
                value={planData.state}
                onChange={(e) => updateData('state', e.target.value)}
                className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2"
              >
                <option value="">Select State</option>
                <option value="AL">Alabama</option>
                <option value="AK">Alaska</option>
                <option value="AZ">Arizona</option>
                <option value="AR">Arkansas</option>
                <option value="CA">California</option>
                <option value="CO">Colorado</option>
                <option value="CT">Connecticut</option>
                <option value="DE">Delaware</option>
                <option value="FL">Florida</option>
                <option value="GA">Georgia</option>
                <option value="HI">Hawaii</option>
                <option value="ID">Idaho</option>
                <option value="IL">Illinois</option>
                <option value="IN">Indiana</option>
                <option value="IA">Iowa</option>
                <option value="KS">Kansas</option>
                <option value="KY">Kentucky</option>
                <option value="LA">Louisiana</option>
                <option value="ME">Maine</option>
                <option value="MD">Maryland</option>
                <option value="MA">Massachusetts</option>
                <option value="MI">Michigan</option>
                <option value="MN">Minnesota</option>
                <option value="MS">Mississippi</option>
                <option value="MO">Missouri</option>
                <option value="MT">Montana</option>
                <option value="NE">Nebraska</option>
                <option value="NV">Nevada</option>
                <option value="NH">New Hampshire</option>
                <option value="NJ">New Jersey</option>
                <option value="NM">New Mexico</option>
                <option value="NY">New York</option>
                <option value="NC">North Carolina</option>
                <option value="ND">North Dakota</option>
                <option value="OH">Ohio</option>
                <option value="OK">Oklahoma</option>
                <option value="OR">Oregon</option>
                <option value="PA">Pennsylvania</option>
                <option value="RI">Rhode Island</option>
                <option value="SC">South Carolina</option>
                <option value="SD">South Dakota</option>
                <option value="TN">Tennessee</option>
                <option value="TX">Texas</option>
                <option value="UT">Utah</option>
                <option value="VT">Vermont</option>
                <option value="VA">Virginia</option>
                <option value="WA">Washington</option>
                <option value="WV">West Virginia</option>
                <option value="WI">Wisconsin</option>
                <option value="WY">Wyoming</option>
                <option value="DC">District of Columbia</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">County</label>
              <input
                type="text"
                value={planData.county}
                onChange={(e) => updateData('county', e.target.value)}
                className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2"
                placeholder="Enter county name"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Filing Context</label>
              <select
                value={planData.filingContext}
                onChange={(e) => updateData('filingContext', e.target.value)}
                className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2"
              >
                <option value="">Select context</option>
                <option value="settlement">Settlement Submission</option>
                <option value="mediation">Mediation Submission</option>
                <option value="consent">Proposed Consent Order Submission</option>
                <option value="court">Court Submission (Formal Filing)</option>
              </select>
            </div>

            {planData.filingContext && (
              <div>
                <label className="block text-sm font-medium mb-2">Which party is submitting this plan?</label>
                <div className="grid grid-cols-2 gap-2">
                  <button onClick={function() { updateData('submittingParty', 'plaintiff'); }}
                    className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' + (planData.submittingParty === 'plaintiff' ? 'border-[#2D2560] bg-[#2D2560]/10' : 'border-white/10 hover:border-white/20')}
                    data-testid="submitting-plaintiff">Plaintiff</button>
                  <button onClick={function() { updateData('submittingParty', 'defendant'); }}
                    className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' + (planData.submittingParty === 'defendant' ? 'border-[#2D2560] bg-[#2D2560]/10' : 'border-white/10 hover:border-white/20')}
                    data-testid="submitting-defendant">Defendant</button>
                </div>
              </div>
            )}

            <div>
              <label className="block text-sm font-medium mb-2">Existing Parenting Order?</label>
              <div className="flex gap-4">
                <button
                  onClick={() => updateData('existingOrder', 'yes')}
                  className={`flex-1 p-3 rounded-lg border transition-all ${
                    planData.existingOrder === 'yes'
                      ? 'border-[#2D2560] bg-[#2D2560]/10'
                      : 'border-white/10 hover:border-white/20'
                  }`}
                >
                  Yes
                </button>
                <button
                  onClick={() => updateData('existingOrder', 'no')}
                  className={`flex-1 p-3 rounded-lg border transition-all ${
                    planData.existingOrder === 'no'
                      ? 'border-[#2D2560] bg-[#2D2560]/10'
                      : 'border-white/10 hover:border-white/20'
                  }`}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        
  );
};
